import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { Box } from "@mui/material";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import * as React from "react";

export default function NumericTile({
  title,
  value,
  deltaPercent,
  color = "primary",
}) {
  const isUp = typeof deltaPercent === "number" && deltaPercent >= 0;
  const DeltaIcon = isUp ? TrendingUpIcon : TrendingDownIcon;

  return (
    <Box sx={{ height: "100%", border: "none" }}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Typography variant="h3" component="p">
          {value}
        </Typography>
        {typeof deltaPercent === "number" && (
          <Chip
            size="small"
            color={isUp ? "success" : "error"}
            icon={<DeltaIcon />}
            label={`${isUp ? "+" : ""}${deltaPercent}%`}
          />
        )}
      </Stack>
    </Box>
  );
}
